<template>
  <div>
    <div class="main-logout">
      <button class="logout" @click="toggleDeleteModal">
        <svg
          width="30px"
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 512 512"
          style="enable-background:new 0 0 512 512;"
          xml:space="preserve"
          fill="#4d4d4d"
        >
          <g>
            <g>
              <path
                d="M360.507,171c8.284,0,15-6.716,15-15V45c0-24.813-20.187-45-45-45h-240c-24.813,0-45,20.187-45,45v422
                    c0,24.813,20.187,45,45,45h240c24.813,0,45-20.187,45-45V356c0-8.284-6.715-15-15-15c-8.284,0-15,6.716-15,15v111
                    c0,8.271-6.729,15-15,15h-240c-8.271,0-15-6.729-15-15V45c0-8.271,6.729-15,15-15h240c8.271,0,15,6.729,15,15v111
                    C345.507,164.284,352.223,171,360.507,171z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M460.15,243.74l-61.421-43.301c-6.771-4.774-16.128-3.153-20.902,3.617c-4.773,6.771-3.154,16.129,3.617,20.903
                        L404.198,241h-231.19c-8.284,0-15,6.716-15,15s6.716,15,15,15h231.19l-22.754,16.042c-6.771,4.773-8.391,14.132-3.617,20.903
                        c4.776,6.774,14.135,8.389,20.902,3.617l61.421-43.301C468.685,262.244,468.529,249.646,460.15,243.74z"
              />
            </g>
          </g>
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
          <g />
        </svg>
      </button>
    </div>

    <main-modal :show="showDeleteModal" :className="'delete-modal'" @close="toggleDeleteModal">
      <delete-modal @close="toggleDeleteModal" @accept="logout" />
    </main-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import deleteModal from "@/components/modals/delete/index";
import mainModal from "@/components/modals/mainModal";

export default {
  name: "main-logout",
  components: {
    deleteModal,
    mainModal
  },
  data() {
    return {
      showDeleteModal: false
    };
  },
  methods: {
    ...mapActions({
      authLogout: "auth/logout"
    }),
    logout() {
      this.authLogout();
    },
    toggleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal;
    }
  }
};
</script>